<template>
  <div :class="['usa-alert', infoOrWarningClass, 'usa-alert--slim']">
    <div class="usa-alert__body">
      <h4 class="usa-alert__heading">{{ title }}</h4>
      <p class="usa-alert__text">
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "USWDSAlert",
  props: {
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    warning: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    infoOrWarningClass() {
      return this.warning ? "usa-alert--warning" : "usa-alert--info";
    },
  },
};
</script>
